"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.destory = exports.start = void 0;

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

var _ravenJs = _interopRequireDefault(require("raven-js"));

var _guid = _interopRequireDefault(require("../utils/guid"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 捕获崩溃
// 打开页面生成UUID 心跳频率 3s 存储在storage里UIID前后2次没有变化且没被清除 表明崩溃
// https://blog.csdn.net/u011001084/article/details/81166925
// 当前页面的心跳标识
var heartbeatKey = "".concat(_constants.PREFIX_HEARTBEAT_KEY).concat((0, _guid.default)()); // 开始心跳 检测是否有崩溃页面

var start = function start() {
  var startTime = Date.now(); // 保存所有页面的心跳

  var heartbeats = {}; // 获取所有页面的心跳标识

  var heartbeatKeys = Object.keys(localStorage).filter(function (key) {
    return key.startsWith(_constants.PREFIX_HEARTBEAT_KEY);
  });

  var loop = function loop() {
    // 保存本页面的url以及运行时间
    localStorage[heartbeatKey] = "".concat(location.href, " ").concat(Date.now() - startTime, "ms");
    heartbeatKeys.forEach(function (key, index) {
      var last = heartbeats[key];
      var now = localStorage[key]; // 页面标识被清除了

      if (!now) {
        delete heartbeats[key];
        return heartbeatKeys.splice(index, 1);
      } // 前后2次相等 说明崩溃
      // TODO:页面发生错误 导致程序不能执行


      if (last === now) {
        delete heartbeats[key];
        localStorage.removeItem(key);
        heartbeatKeys.splice(index, 1);
        return _ravenJs.default.captureException(new Error("Page Crash captured: ".concat(last)));
      }

      return heartbeats[key] = now;
    });
    var timer = setTimeout(function () {
      loop();
      clearTimeout(timer);
    }, _constants.HEARTBEAT_INTERVAL);
  };

  loop();
}; // 页面卸载时销毁心跳标识


exports.start = start;

var destory = function destory() {
  return localStorage.removeItem(heartbeatKey);
};

exports.destory = destory;